export default __webpack_public_path__ + "baslamadi.png";